import { render, staticRenderFns } from "./DepartmentParentPicker.vue?vue&type=template&id=410457ce&scoped=true"
import script from "./DepartmentParentPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./DepartmentParentPicker.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DepartmentParentPicker.vue?vue&type=style&index=0&id=410457ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410457ce",
  null
  
)

export default component.exports